<template>
    <div>
        <div class="second-header-wrap">
            <el-input placeholder="请输入资源" v-model.trim="searchTitle" class="search-input" @keyup.enter.native="searchTitleHandler">
                <el-button slot="append" icon="el-icon-search" @click="searchTitleHandler"></el-button>
            </el-input>
            <el-select v-if="isAdmin || isAccountant" size="medium" @change="areaOrSchoolTypeChange" v-model="searchPostCode" placeholder="请选择">
                <el-option
                    v-for="(postcodeItem, index) in postcodeList"
                    :key="postcodeItem.areaCode"
                    :label="postcodeItem.areaName"
                    :value="postcodeItem.areaCode">
                </el-option>
            </el-select>

            <el-radio-group v-if="isAdmin || isAccountant" @change="areaOrSchoolTypeChange" v-model="schoolType" size="medium">
                <el-radio-button :key="0" :label="0">全部</el-radio-button>
                <el-radio-button v-for="(periodItem, index) in schoolPeriodList" :key="index + 1" :label="periodItem.code">
                    {{periodItem.value}}
                </el-radio-button>
            </el-radio-group>
        </div>
        <div class="main-content-wrap">
            <div v-if="dataList && dataList.length !== 0" class="inner-content-wrap custom—scrollbar">
                <div class="main-container">
                    <ul>
                        <li @click="jumpToPage('resourceDetail', {resourceId: resourceItem.id, fromType: 'user'})" class="resource-card-item" :key="index" v-for="(resourceItem, index) in dataList">
                            <div class="inner-card-wrap">
                                <div class="item-img-wrap">
                                    <div class="item-cover"
                                         :style="{backgroundImage: `url(${resourceItem.resourceLogo})`}">
                                    </div>
                                </div>
                                <div class="card-msg-wrap">
                                    <div>
                                        <el-tooltip class="item" effect="dark" :content="resourceItem.resourseName" placement="top">
                                            <div class="resource-name">{{resourceItem.resourseName}}</div>
                                        </el-tooltip>
                                    </div>
                                    <div class="resource-title clearfix">
                                        <div><i class="fa fa-eye"></i>观看:<span>{{resourceItem.visitorCount}}</span></div>
                                        <div><i class="fa fa-thumbs-o-up"></i>点赞:<span>{{resourceItem.praiseCount}}</span></div>
                                        <div><i class="fa fa-comment-o"></i>评论:<span>{{resourceItem.commentCount}}</span></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
            <div v-if="dataList && dataList.length !== 0" class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[8, 16, 32]"
                    :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
            <default-page style="height: 740px;" v-else></default-page>
        </div>

    </div>
</template>

<script>
    import DefaultPage from '@/components/DefaultPage';
    import baseMixin from '@/mixins/baseMixin.js';
    import { findDicsByCode } from '@/api/common/common';
    import { getSchoolResourcePageList, getManagerResourcePageList, getUserManageAreaCodeList, getUserStaticAreaCodeList, getStaticianResourcePageList } from '@/api/resourceManagement/resourceManagement';
    import {mapGetters} from 'vuex';

    export default {
        name: "resourceIndex",
        data() {
            return {
                dataList: [],
                searchTitle: '',
                searchTitleArg: '',
                searchType: null,
                isAdmin: false,
                isAccountant: false,
                postcodeList: [],
                searchPostCode: null,
                schoolType: 0,
                schoolPeriodList: []
            }
        },
        components: {
            DefaultPage
        },
        computed: {
            ...mapGetters(['userInfo', 'permission'])
        },
        mixins: [baseMixin],
        created() {
            this.isAdmin = this.permission.indexOf('/videoResourcePlatform/videoResourcePlatformAdmin') !== -1;
            this.isAccountant = this.permission.indexOf('/videoResourcePlatform/videoResourcePlatformAccountant') !== -1;

            sessionStorage.setItem('addWatch', 1);
            this.searchType = this.userInfo.type.indexOf('1') !== -1 ? 2 : 1;
            if(location.search) {
                location.search = '';
            }
            this.pagination.pageSize = 8;

            if(this.isAdmin) {
                Promise.all([
                    getUserManageAreaCodeList()
                        .then(res => res.data)
                        .then(data => {
                            this.postcodeList = [...data.data];
                            this.searchPostCode = data.data[0].areaCode;
                        }),

                    findDicsByCode({
                        dicCode: 'schoolPeriodType'
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.data.length > 0) {
                                this.schoolPeriodList = data.data.filter(item => item.code !== '0');
                            }
                        })
                ])
                    .then(() => {
                        this.getResourceList();
                    })
            } else if(this.isAccountant) {
                Promise.all([
                    getUserStaticAreaCodeList()
                        .then(res => res.data)
                        .then(data => {
                            this.postcodeList = [...data.data];
                            this.searchPostCode = data.data[0].areaCode;
                        }),

                    findDicsByCode({
                        dicCode: 'schoolPeriodType'
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.data.length > 0) {
                                this.schoolPeriodList = data.data.filter(item => item.code !== '0');
                            }
                        })
                ])
                    .then(() => {
                        this.getResourceList();
                    })
            } else {
                this.getResourceList();
            }


        },
        methods: {
            areaOrSchoolTypeChange() {
                this.pagination.pageNo = 1;
                this.getResourceList();
            },
            searchTitleHandler() {
                this.pagination.pageNo = 1;
                this.searchTitleArg = this.searchTitle;
                this.getResourceList();
            },
            sizeChangeHandler(pageSize) {
                this.pagination.pageSize = pageSize;
                this.pagination.pageNo = 1;
                this.getResourceList();
            },
            currentChangeHandler(pageNo) {
                this.pagination.pageNo = pageNo;
                this.getResourceList();

            },
            getResourceList() {
                new Promise((resolve) => {
                    if(this.isAdmin) {
                        getManagerResourcePageList({
                            areaCode: this.searchPostCode,
                            pageNo: this.pagination.pageNo,
                            pageSize: this.pagination.pageSize,
                            searchTitle: this.searchTitleArg,
                            searchType: this.schoolType
                        })
                            .then(res => res.data)
                            .then(data => {
                                resolve(data)
                            });
                    }  else if(this.isAccountant) {
                        getStaticianResourcePageList({
                            areaCode: this.searchPostCode,
                            pageNo: this.pagination.pageNo,
                            pageSize: this.pagination.pageSize,
                            searchTitle: this.searchTitleArg,
                            searchType: this.schoolType
                        })
                            .then(res => res.data)
                            .then(data => {
                                resolve(data)
                            });
                    } else {
                        getSchoolResourcePageList({
                            pageNo: this.pagination.pageNo,
                            pageSize: this.pagination.pageSize,
                            searchTitle: this.searchTitleArg,
                            searchType: this.searchType
                        })
                            .then(res => res.data)
                            .then(data => {
                                resolve(data)
                            });
                    }
                })
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.pagination.total = data.data.pagination.total;
                        this.pagination.pages = data.data.pagination.pages;
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    @include reset-global;

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 90px;
        line-height: 74px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
        box-sizing: border-box;
    }

    .main-content-wrap {
        width: 100%;
        height: 100%;
        margin-top: 180px;
        background: url(../../assets/images/common/content-bg.jpg) center center / 100% 100% no-repeat;
        .inner-content-wrap {
            width: 100%;
            overflow-y: auto;
            height: 740px;

            .main-container {
                width: 1320px;
                padding: 22px;
                margin: 0 auto;
                min-height: 560px;
                ul {
                    margin-left: -20px;
                    .resource-card-item {
                        float: left;
                        width: 315px;
                        height: 240px;
                        position: relative;
                        -webkit-transition: .3s all linear;
                        transition: .3s all linear;
                        margin-left: 20px;
                        margin-bottom: 50px;
                        background: #fff;
                        box-shadow: 1px 1px 1px 1px #ddd;
                        -webkit-box-shadow: 1px 1px 1px 1px #ddd;
                        .inner-card-wrap {
                            display: block;
                            width: 100%;
                            height: 100%;
                            text-decoration: none;
                            color: initial;
                            cursor: pointer;
                            .item-img-wrap {
                                margin-bottom: 5px;
                                width: 100%;
                                height: 175px;
                                overflow: hidden;
                                position: relative;
                                .item-cover {
                                    @include full;
                                    @include cover-bg;
                                    transition: all 0.6s;
                                }

                            }
                            .card-msg-wrap {
                                width: 96%;
                                padding: 0 2%;
                                overflow: hidden;
                                div {
                                    line-height: 1.6em;
                                }
                                .resource-name {
                                    @include nowrap;
                                    color: #525151;
                                    font-family: "Microsoft YaHei";
                                    font-weight: bold;
                                }
                                .resource-title {
                                    font-size: 17px;
                                    & > * {
                                        @include middleIB;
                                        width: 32%;
                                        font-size: 14px;
                                    }
                                    .fa {
                                        margin-right: 5px;
                                        color: #20a0ff;
                                    }
                                    span {
                                        color: #999;
                                    }
                                }
                            }
                        }
                        &:hover {
                            .item-cover {
                                transform: scale(1.15);
                            }
                        }
                    }
                }
            }
        }
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }
    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }
    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }
    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }
    .pagination-container {
        text-align: right;
        width: 1320px;
        margin: 10px auto 0 auto;
    }
    .search-input {
        vertical-align: middle;
        margin-left: 10px;
        width: 240px;
    }
</style>



// WEBPACK FOOTER //
// src/views/resourceIndex/resourceIndex.vue